// Action creators for updating the map

import {
  CHANGE_GRID_SIZE,
  CHANGE_GRID_ROTATION,
  CHANGE_GRID_OFFSET,
  UPDATE_MAP,
  SELECT_FEATURE,
  SELECT_JOB,
  SELECT_JOB_FEATURE,
  TOGGLE_HOVER_FEATURE,
  EDIT_SELECTED_FIELD,
  DELETE_SELECTED_FIELD,
  TOGGLE_HOVER_POINT,
  CHANGE_BASE_LAYER,
  TOGGLE_PANEL,
  SELECT_SOIL_TEST_FILTER,
  TOGGLE_IMAGERY_LAYERS,
  CENTER_MAP_DEFAULT,
  CENTER_MAP_TO_FARM,
  CENTER_MAP_TO_FIELD,
  SET_USER_STATE_BBOX,
  SHOW_PREVIOUS_POINTS,
} from './constants'

export function togglePanel () {
  return {
    type: TOGGLE_PANEL,
  }
}

export function editSelectedField () {
  return {
    type: EDIT_SELECTED_FIELD,
  }
}

export function deleteSelectedField () {
  return {
    type: DELETE_SELECTED_FIELD,
  }
}

export function updateMap (payload) {
  return {
    type: UPDATE_MAP,
    payload,
  }
}

export function selectFeature (payload) {
  return {
    type: SELECT_FEATURE,
    payload,
  }
}

export function selectJobFeature (payload) {
  return {
    type: SELECT_JOB_FEATURE,
    payload,
  }
}

export function toggleHoverFeature (payload) {
  return {
    type: TOGGLE_HOVER_FEATURE,
    payload,
  }
}

export function toggleHoverPoint (payload) {
  return {
    type: TOGGLE_HOVER_POINT,
    payload,
  }
}

// TODO: These are temporary action creators for testing HEF-258
export function changeGridSize (payload) {
  return {
    type: CHANGE_GRID_SIZE,
    payload,
  }
}

export function changeGridRotation (payload) {
  return {
    type: CHANGE_GRID_ROTATION,
    payload,
  }
}

export function changeGridOffset (payload) {
  return {
    type: CHANGE_GRID_OFFSET,
    payload,
  }
}

export function changeBaseLayer (payload) {
  return {
    type: CHANGE_BASE_LAYER,
    payload,
  }
}

export function selectJob (payload) {
  return {
    type: SELECT_JOB,
    payload,
  }
}

export function selectSoilTestFilter (payload) {
  return {
    type: SELECT_SOIL_TEST_FILTER,
    payload,
  }
}

export function toggleImageryLayers () {
  return {
    type: TOGGLE_IMAGERY_LAYERS,
  }
}

export function showPreviousPoints (payload) {
  return {
    type: SHOW_PREVIOUS_POINTS,
    payload,
  }
}

export function centerMapDefault () {
  return {
    type: CENTER_MAP_DEFAULT,
  }
}

export function centerMapToFarm ({ seasonId, farmId }) {
  return {
    type: CENTER_MAP_TO_FARM,
    seasonId,
    farmId,
  }
}

export function centerMapToField (fieldId) {
  return {
    type: CENTER_MAP_TO_FIELD,
    fieldId,
  }
}

export function setUserStateBbox (payload) {
  return {
    type: SET_USER_STATE_BBOX,
    payload,
  }
}
